// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"Charts_chartContainer__3sGu8","BarChart":"Charts_BarChart__2a0di","PieChart":"Charts_PieChart__YVBrg","chartName":"Charts_chartName__2g0h4"};